module.exports = __webpack_public_path__ + "img/_weapon_potion_08.c63072fa.png";